module.exports = __webpack_public_path__ + "img/instagram.5c570427.png";